import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { EnlargedReturnIconContainer, RemoveIcon } from '@atlassian/search-dialog';
import { IconButton } from '@atlaskit/button/new';
import { messages } from '../messages';
import { useQuickFindRovoTip } from './use-quick-find-rovo-tip';
import { useInputContext } from '../../input-context';
var RovoTipMessageStyle = xcss({
  width: '95%',
  marginLeft: 'space.050',
  paddingTop: 'space.100',
  paddingBottom: 'space.100',
  paddingLeft: 'space.050'
});
var RovoTipContainerStyle = xcss({
  paddingTop: 'space.075',
  paddingLeft: 'space.100',
  paddingRight: 'space.100'
});
var RovoTipStyle = xcss({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  minHeight: "var(--ds-space-500, 40px)",
  paddingLeft: 'space.150',
  paddingRight: 'space.100',
  borderRadius: "var(--ds-space-050, 4px)",
  backgroundColor: 'color.background.accent.purple.subtlest',
  color: 'color.text.accent.purple'
});
export var QuickFindRovoTip = function QuickFindRovoTip() {
  var _useQuickFindRovoTip = useQuickFindRovoTip(),
    showRovoTip = _useQuickFindRovoTip.showRovoTip,
    dismissRovoTip = _useQuickFindRovoTip.dismissRovoTip;
  var _useInputContext = useInputContext(),
    focusInput = _useInputContext.focusInput;
  if (!showRovoTip) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: RovoTipContainerStyle
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: RovoTipStyle
  }, /*#__PURE__*/React.createElement(LightbulbIcon, {
    label: "blank",
    color: "var(--ds-text-accent-purple, #5E4DB2)"
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: RovoTipMessageStyle
  }, /*#__PURE__*/React.createElement("b", null, "Rovo tip:"), " ", /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_rovo_tip)), /*#__PURE__*/React.createElement(EnlargedReturnIconContainer, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: RemoveIcon,
    spacing: 'compact',
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      dismissRovoTip();
      focusInput && focusInput();
    },
    label: /*#__PURE__*/React.createElement(FormattedMessage, messages.remove_button_label),
    appearance: 'subtle'
  }))));
};